export default {
  state: {
    sys_name: 'IG-CIE',
    subjects: [
      {
        name: 'Mathematics',
        icon: 'mdi-function-variant'
      },{
        name: 'Mathematics - Additional',
        icon: 'mdi-function-variant'
      },{
        name: 'Physics',
        icon: 'mdi-electron-framework'
      },{
        name: 'Chemistry',
        icon: 'mdi-flask'
      },{ 
        name: 'Biology', 
        icon: 'mdi-leaf' 
      },{ 
        name: 'Computer Science', 
        icon: 'mdi-web' 
      },{ 
        name: 'Economics', 
        icon: 'mdi-piggy-bank-outline' 
      },
    ]
  }
}